import axios from "axios"
export const loginCall  = async (userCredentials, dispatch) => {
    dispatch({type: "LOGIN_START"});
    try{
        const res = await axios.post("https://backendwhistler.herokuapp.com/api/auth/login/", userCredentials);
        //const res = await axios.post("http://localhost:8800/api/auth/login/", userCredentials);
        const token = res.data.token;
        if(token)
            localStorage.setItem('token',token);
        dispatch({type: "LOGIN_SUCCESS", payload: res.data.user});
    }catch(err){
        dispatch({type: "LOGIN_FAILURE", payload: err});
        

    }
}

//